import { render, staticRenderFns } from "./MachineRenewal.vue?vue&type=template&id=6f180836"
import script from "./MachineRenewal.vue?vue&type=script&lang=js"
export * from "./MachineRenewal.vue?vue&type=script&lang=js"
import style0 from "./MachineRenewal.vue?vue&type=style&index=0&id=6f180836&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports